export default __webpack_public_path__ + "static/media/H0003.554bb58d.png";